export type TenantType = "agent" | "company";
export type TenantSelection = {
  id: number;
  name: string;
  type: TenantType;
  actorId: number | string;
  role?: string;
  capabilities?: string[];
};

const key = "job-admin-tenant";

export function getTenantSelection(): TenantSelection | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) ?? "null");
    return value &&
      ["agent", "company"].includes(value.type) &&
      Number.isSafeInteger(value.id) &&
      value.id > 0 &&
      typeof value.name === "string"
      ? value
      : null;
  } catch {
    return null;
  }
}

export function clearTenantSelection() {
  sessionStorage.removeItem("job-admin-reason");
  sessionStorage.removeItem(key);
  sessionStorage.removeItem("initials");
}

export function openTenant(selection: TenantSelection, path = "/jobs") {
  sessionStorage.setItem(key, JSON.stringify(selection));
  sessionStorage.removeItem("initials");
  // Remount all forms and requests so data from one organization cannot be
  // submitted while another organization's context is active.
  window.location.assign(path);
}
